<template v-if="cms.heading">
  <!-- eslint-disable vue/no-v-html -->
  <component :is="htmlTag" :class="[name, getClassName]" v-html="cms.heading" />
  <!--eslint-enable-->
</template>

<script>
import data from '~/components/atoms/a-headings/a-heading.data'

export default {
  props: {
    htmlTag: {
      type: String,
      default: 'h2',
    },
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'a-heading',
    }
  },
  computed: {
    getClassName() {
      return this.cms ? this.cms.heading_size : ''
    },
  },
}
</script>

<style lang="scss" scoped>
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  @include font-family($font-family-headings, 600);

  margin: 0 0 30px;
}
h2,
.h2 {
  @include font-size(36, 40.8px);
}
h1,
.h1 {
  @include font-size(36, 40.8px);
}
h3,
.h3 {
  @include font-size(25.6, 30.72px);
}
h4,
h5,
h6,
.h4,
.h5,
.h6 {
  @include font-size(16, 19.2px);
}

@include media-breakpoint-up(md) {
  h2,
  .h2 {
    @include font-size(65, 80px);
  }
  h1,
  .h1 {
    @include font-size(83, 96px);
  }
  h3,
  .h3 {
    @include font-size(46, 57px);
  }
  h4,
  h5,
  h6,
  .h4,
  .h5,
  .h6 {
    @include font-size(28, 33.6px);
  }
}

@include media-breakpoint-up(lg) {
  h2,
  .h2 {
    @include font-size(83, 96px);
  }
  h1,
  .h1 {
    @include font-size(105, 124px);
  }
  h3,
  .h3 {
    @include font-size(58, 72px);
  }
  h4,
  h5,
  h6,
  .h4,
  .h5,
  .h6 {
    @include font-size(36, 40.8px);
  }
}
</style>
